import { observable, action } from 'mobx';
import { navList } from '@src/constants/const';
import { getHashParams } from '@src/utils/query-string-util.js';

/**
 * 组件加载管理 Store - 极简版
 * 策略：首屏只加载当前组件，延迟后一次性加载所有剩余组件
 */
class LoadComponentsStore {
  /** 已渲染的页面集合 */
  @observable renderedPages = new Set();

  /** 所有页面的 key 列表 */
  pageKeys = navList.map(item => item.key);

  /** 预加载是否已启动 */
  isPreloadStarted = false;

  constructor() {
    // 初始化：仅添加当前 anchor 对应的页面
    const initialAnchor = getHashParams().anchor || 'home';
    this.renderedPages.add(initialAnchor);
  }

  /**
   * 判断页面是否应该渲染
   * @param {string} pageKey - 页面标识
   * @returns {boolean}
   */
  shouldRender(pageKey) {
    return this.renderedPages.has(pageKey);
  }

  /**
   * 标记页面为已渲染
   * @param {string} pageKey - 页面标识
   */
  @action
  markAsRendered(pageKey) {
    this.renderedPages.add(pageKey);
  }

  /**
   * 更新当前激活页面
   * @param {string} pageKey - 页面标识
   */
  @action
  setCurrentPage(pageKey) {
    this.markAsRendered(pageKey);
  }

  /**
   * 延迟加载所有组件
   * 策略：使用 requestIdleCallback 或在页面完全加载后延迟加载，避免阻塞首屏
   */
  @action
  startDelayedPreload() {
    if (this.isPreloadStarted) return;
    this.isPreloadStarted = true;

    const preloadTask = () => {
      this.pageKeys.forEach(pageKey => {
        this.markAsRendered(pageKey);
      });
      console.log('[预加载] 所有组件已加载完成');
    };

    // 优先使用 requestIdleCallback
    if (window.requestIdleCallback) {
      requestIdleCallback(() => {
        preloadTask();
      });
    } else {
      // 降级方案：确保在 load 事件后执行
      if (document.readyState === 'complete') {
        setTimeout(preloadTask, 1000);
      } else {
        window.addEventListener('load', () => setTimeout(preloadTask, 1000));
      }
    }
  }
}

export default LoadComponentsStore;
